module.exports = {"question_title":"Select your security question","question_description":"Enter your answer in the next screen","answer_title":"Security question answer","answer_placeholder":"Enter your answer","answer_question":"Your answer to the security question: {{question}}","questions":{"secquestion5":"Mother's maiden name","secquestion1":"My first pets name","secquestion2":"My first car","secquestion3":"My first school"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/securityQuestion.json
// module id = 662
// module chunks = 247 1431